import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import {
  ItemDisplay,
  LeverageCard,
  LeverageCardRow,
  PercentagePicker,
} from './leverageComponents';
import { LeverageCardProps } from '../leverageStep';
import { FixFlipGULeverageMatrixCard } from './fixFlipGULeverageMatrixCard';
import { useEffect } from 'react';

export const StabilizedBridgeLeverageCard = observer(
  ({ store, disabled, instaQuote = false, showEmptyValues = false, quoteTypeStore, manualQuoteSubTitle, onPercentageChange }: LeverageCardProps) => {
    const { loanEconomicsStore } = store;
    const calculated = store.calculatedFields;
    const ranges = store.ranges;

    const totalLoanAmountGreaterThan3M = () => {
      if (loanEconomicsStore.enableManualQuote) {
        loanEconomicsStore.setIsTotalLoanAmountGreaterThan3M(calculated.totalLoanAmount > 3000000)
      } else {
        loanEconomicsStore.setIsTotalLoanAmountGreaterThan3M(calculated.totalLoanAmount > 3000000)
      }
    }

    useEffect(() => {
      if (onPercentageChange) {
        onPercentageChange();
      }
    }, [store.form.fields.loanToCost.value]);

    const handleLoanToCost = (value) => {
      store.onFieldChange('loanToCost', value)
      totalLoanAmountGreaterThan3M();
    }

    return (
      <LeverageCard
        title={
          instaQuote ? 'Insta-Leverage Quote' : 'Request Leverage'
        }
        disabled={disabled}
        instaQuote={instaQuote}
        LeverageMatrixCard={instaQuote ? FixFlipGULeverageMatrixCard : undefined}
        quoteTypeStore={quoteTypeStore}
        disabledWarning={showEmptyValues}
        subtitle={manualQuoteSubTitle}
      >
        {
          !quoteTypeStore.showOnlyLTVValues &&
          <LeverageCardRow
            dividend={
              <ItemDisplay
                label={'Loan Amount'}
                value={showEmptyValues ? '-' : formatCurrency(calculated.totalLoanAmount)}
                instaQuote={instaQuote}
              />
            }
            divisor={
              <ItemDisplay
                label={quoteTypeStore.getCostBasisLabel()}
                value={showEmptyValues ? '-' : formatCurrency(calculated.totalPurchasePrice)}
              />
            }
            result={
              <PercentagePicker
                fieldName={'loanToCostPercentage'}
                label={"Loan to Cost"}
                disabled={disabled}
                instaQuote={instaQuote}
                value={showEmptyValues ? 0 : store.form.fields.loanToCost.value}
                min={ranges?.minLoanToCost}
                max={ranges?.maxLoanToCost}
                onChange={value => handleLoanToCost(value)}
              />
            }
          />
        }
        <LeverageCardRow
          dividend={
            <ItemDisplay
              label="Total Loan Amount"
              value={showEmptyValues ? '-' : formatCurrency(calculated.totalLoanAmount)}
              instaQuote={instaQuote}
            />
          }
          divisor={
            <ItemDisplay
              label="Market Value"
              value={showEmptyValues ? '-' : formatCurrency(calculated.totalMarketValue)}
            />
          }
          result={
            quoteTypeStore.showOnlyLTVValues ?
              <PercentagePicker
                fieldName={'loanToCostPercentage'}
                label={"Loan to Value"}
                disabled={disabled}
                instaQuote={instaQuote}
                value={showEmptyValues ? 0 : store.form.fields.loanToCost.value}
                min={ranges?.minLoanToCost}
                max={ranges?.maxLoanToCost}
                onChange={value => handleLoanToCost(value)}
              /> :
              <ItemDisplay
                label="Loan To Value"
                value={showEmptyValues ? '-' : formatPercentage(calculated.calculatedLTV)}
                instaQuote={instaQuote}
              />
          }
        />
      </LeverageCard>
    );
  }
);
